import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from '../styles/modal.module.css'
import StateContext from '../context/state/StateContext'
import Loading from './Loading'
import axios from 'axios'
import { toast } from 'react-toastify'
import UserContext from '../context/user/UserContext';
import { FaLink } from "react-icons/fa6";
import { AiOutlineFolderOpen } from "react-icons/ai";
import { IoMdAlarm } from "react-icons/io";
import { IoFlag } from "react-icons/io5";
import { IoCheckmarkSharp } from "react-icons/io5";
import { IoIosMic } from "react-icons/io";
import Links from './Links';
import useVoiceRecorder from './useVoiceRecorder';
import { FaRegCircleStop } from "react-icons/fa6";
import { DateCalendar } from '@mui/x-date-pickers'
import StarRating from './StarRating'

const SupportNote = ({ open, close, status, setStatus, data, action, setAction }) => {

    const { ticket, setTicket, client, token, setSuccess, setDetail, ticketIds, tickets, setTickets, employees, setLoading, delayRequest, setDelayRequest, setRequests } = useContext(StateContext)
    const { user } = useContext(UserContext);
    const [disabled, setDisabled] = useState(true);
    const { isRecording, audioBlob, startRecording, stopRecording, setAudioBlob } = useVoiceRecorder();
    const [fields, setFields] = useState({ component: '', open: false });
    const [link, setLink] = useState('');
    const [links, setLinks] = useState([]);
    const [files, setFiles] = useState([]);
    const [note, setNote] = useState('');
    const [error, setError] = useState('');
    const [delayDate, setdelayDate] = useState(null)
    const [rating, setRating] = useState(0);

    const modalRef = useRef();

    const handleModelCLickedOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            handelClose()
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleModelCLickedOutside);
        return () => {
            document.removeEventListener('mousedown', handleModelCLickedOutside);
        };
    }, []);

    const handleChange = (e) => {
        setDisabled(false);
        setError('')
        setNote(e.target.value)
    }



    const handleFileChange = async (event) => {
        const fileList = event.target.files;
        // Convert FileList to Array and limit it to 5 files
        // const fileArray = Array.from(fileList).slice(0, 5);

        if (fileList.length > 5) {
            setError('You can only upload a maximum of 5 files.');
        } else {
            setError('');
            setFiles(fileList); // Update state with valid files
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading({ open: true, text: 'Saving...' })

            const formData = new FormData();
            // formData.append('clientId', data.clientId);
            // formData.append('employeeId', data.employeeId);
            formData.append('requestId', data.id);
            formData.append('note', note);
            formData.append('action', action);
            formData.append('status', status);
            formData.append('rating',rating)
            formData.append('links', JSON.stringify(links)); // Serialize links array

            for (let i = 0; i < files.length; i++) {
                formData.append('uploads', files[i]);
            }
            // Append audio
            if (audioBlob) {
                formData.append('audio', audioBlob, 'recording.webm');
            }

            const response = await axios.post(process.env.REACT_APP_API_URL + "api/request/addSupportNote", formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'auth-token': `${token}`
                    },
                })

            const json = response.data;
            if (json.success) {
                setNote('')
                setAction("")
                toast.success(json.message)
                if (status === "completed") {
                    setSuccess(true)
                    setStatus('')
                }
                // setFiles([])
                // setdelayDate('')
                // setAudioBlob(null)
                setRequests(prevRequests =>
                    prevRequests.map(request =>
                        request.id === data.id ? { ...request, ...json.updatedRequest } : request
                    )
                );
                setDetail({ open: true, data: json.updatedRequest })
                close(false)
            } else {
                toast.error(json.message)
                setError(json.message || json.message[0].msg)
            }

        } catch (error) {
            console.log(error);
            setError(error.response.data.message || error.response.data.message[0].msg)
            toast.error(error)
        } finally {
            setLoading({ open: false, text: '' })
            setDelayRequest(false);
        }
    }

    const todayDate = () => {
        let date = new Date();
        return date.getDate();
    };
    const handleDate = (e) => {
        setDisabled(false)
        setdelayDate(e.target.value)
    }

    const handelClose = () => {
        close(false);
        setError('')
        setNote('')
        setAction("")
        setDelayRequest('')
        setStatus('')
        setFiles([])
        setAudioBlob(null)
        setdelayDate('')
    }

    const handleRatingChange = (newRating) => {
        setRating(newRating);
    };


    return (
        <>
            <div className={`${styles.modal} ${open ? styles.active : ''}`}>
                <div className={styles.backDrop}></div>
                <div className={styles.box} ref={modalRef}>
                    <Loading />
                    <form onSubmit={handleSubmit}>
                        <div className={styles.head}>
                            <h3>{(action === "accept" || action === "reject") ? "Give Feedback" : "Leave a Note"}</h3>
                            <i className={`bx bx-x ${styles.close}`} onClick={handelClose}></i>
                        </div>
                        <div className={styles.form_container}>
                            <label htmlFor="" className='mb-2 label'>{(action === "accept" || action === "reject" ) ? "Please give your feedback here" : `Please add a note before marking the request as ${status}`}</label>
                            {(action === "accept" || action === "reject") ? 
                            <>
                            <div className="inputField" style={{ border: "1px solid #ddd", borderRadius: "12px", padding: "10px" }}>
                                <StarRating onRatingChange={handleRatingChange} />
                                {/* <p>Selected Rating: {rating} / 5</p> */}
                            </div>
                            </>
                            :
                            <div className="inputField" style={{ border: "1px solid #ddd", borderRadius: "12px" }}>
                                <textarea value={note} name="note" onChange={handleChange} id="" placeholder='Leave note here...' rows={4}></textarea>
                            </div>
                            }
                            {/* {data.request_delay === "requested" && (user.role === "admin" || data.generatedById === user.id) && action !== "rejected_request" ? <>
                                <label htmlFor="" className='mb-2 label'>Select due date</label>
                                <div className="inputField" style={{ border: "1px solid #ddd" }}>
                                    <input type="date" placeholder='Select Date' name='date' min={new Date().toISOString().split("T")[0]} required onChange={handleDate} />
                                </div> </> : null} */}
                            {error ? <p style={{ color: "red" }}>{error}</p> : null}
                            {(action === "accept" || action === "reject") ? <></>:  <><p className={styles.para}>You can upload up to 5 files</p>
                            <div className="d-flex align-items-center flex-wrap" style={{ gap: "15px" }}>
                                <label htmlFor='upload' className={styles.icon} data-attr="Upload Files">
                                    <input type="file" style={{ display: "none" }} 
                                    onChange={handleFileChange} multiple id='upload' />
                                    
                                    <AiOutlineFolderOpen />
                                </label>
                                {files.length > 0 ?
                                    <div className={styles.files}>
                                        {Array.from(files).map((item, index) => {
                                            return <span key={index} className={styles.file}>{item.name}{files.length > index ? ',' : null}</span>
                                        })}
                                    </div> : null}
                                {!isRecording ? (
                                    <div className={styles.icon} data-attr="Start Recording" onClick={() => { startRecording(); setDisabled(false) }}>
                                        <IoIosMic />
                                    </div>
                                ) : (
                                    <div className={styles.icon} data-attr="Stop Recording" onClick={stopRecording}>
                                        <FaRegCircleStop />
                                    </div>
                                )}
                                {audioBlob && (
                                    <div>
                                        <audio controls src={URL.createObjectURL(audioBlob)} />
                                    </div>
                                )}
                            </div></>}
                        </div>

                        <div className={styles.foot}>
                            <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                                <button type='button' className="button2 cancel" onClick={handelClose}>Cancel</button>
                                <button type='submit' className={`button2`}>Update</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default SupportNote
